import { ColDef } from "ag-grid-enterprise";
export const coldefs1:ColDef[] = [
        {
            field:'location',
            headerName:'Location Name',
            colId:'location',
        },
        
        {
            field:'whcode',
            headerName:'Location Code',
            colId:'whcode',
        },
        {
            field:'countSku',
            headerName:'Count Of Skus',
            colId:'countSku',
        }
        ,
        {
        field:'blackCount',
        colId:'blackCount',
        headerName:'Black'
        
        },
        {
        field:'redCount',
        colId:'redCount',
        headerName:'Red'
        },
         {
            field:'LogisticsLocation',
            headerName:'LogisticsLocation',
            colId:'LogisticsLocation',
        },
         {
            field:'LL1',
            headerName:'LL1',
            colId:'LL1',
        },
         {
            field:'LL2',
            headerName:'LL2',
            colId:'LL2',
        },
         {
            field:'LL3',
            headerName:'LL3',
            colId:'LL3',
        },
         {
            field:'LL4',
            headerName:'LL4',
            colId:'LL4',
        },
         {
            field:'LL5',
            headerName:'LL5',
            colId:'LL5',
        },
         {
            field:'c1',
            headerName:'C1',
            colId:'c1',
        },
         {
            field:'C2',
            headerName:'C2',
            colId:'C2',
        },
         {
            field:'C3',
            headerName:'C3',
            colId:'C3',
        },
         {
            field:'C4',
            headerName:'C4',
            colId:'C4',
        },
         {
            field:'C5',
            headerName:'C5',
            colId:'C5',
        },
         {
            field:'C6',
            headerName:'C6',
            colId:'C6',
        },
         {
            field:'C7',
            headerName:'C7',
            colId:'C7',
        },
         {
            field:'C8',
            headerName:'C8',
            colId:'C8',
        },
         {
            field:'C9',
            headerName:'C9',
            colId:'C9',
        },
         {
            field:'C10',
            headerName:'C10',
            colId:'C10',
        },
         {
            field:'C11',
            headerName:'C11',
            colId:'C11',
        },
        {
            field:'C12',
            headerName:'C12',
            colId:'C12',
        },
        {
            field:'C13',
            headerName:'C13',
            colId:'C13',
        },
        {
            field:'C14',
            headerName:'C14',
            colId:'C14',
        },
        {
            field:'C15',
            headerName:'C15',
            colId:'C15',
        },
    ]

export const coldefs2:ColDef[] = [
        {
            field:'sku',
            headerName:'SKU Code',
            colId:'sku',
        },
        {
            field:'countloc',
            headerName:'Count Of Locations',
            colId:'countloc',
        },
          {
            field:'blackCount',
            colId:'blackCount',
            headerName:'Black'
          },
           {
            field:'redCount',
            colId:'redCount',
            headerName:'Red'
        },
         {
            field:'SKUDescription',
            headerName:'SKUDescription',
            colId:'SKUDescription',
        },
         {
            field:'elephantOrderCapping',
            headerName:'ElephantOrderCapping',
            colId:'elephantOrderCapping',
        },
         {
            field:'weight',
            headerName:'Weight',
            colId:'weight',
        },
         {
            field:'volume',
            headerName:'Volume',
            colId:'volume',
        },
        {
            field:'SL1',
            headerName:'SL1',
            colId:'SL1',
        },
         {
            field:'SL2',
            headerName:'SL2',
            colId:'SL2',
        },
         {
            field:'SL3',
            headerName:'SL3',
            colId:'SL3',
        },
         {
            field:'SL4',
            headerName:'SL4',
            colId:'SL4',
        },
         {
            field:'SL5',
            headerName:'SL5',
            colId:'SL5',
        },
         {
            field:'c1',
            headerName:'C1',
            colId:'c1',
        },
         {
            field:'C2',
            headerName:'C2',
            colId:'C2',
        },
         {
            field:'C3',
            headerName:'C3',
            colId:'C3',
        },
         {
            field:'C4',
            headerName:'C4',
            colId:'C4',
        },
         {
            field:'C5',
            headerName:'C5',
            colId:'C5',
        },
         {
            field:'C6',
            headerName:'C6',
            colId:'C6',
        },
         {
            field:'C7',
            headerName:'C7',
            colId:'C7',
        },
         {
            field:'C8',
            headerName:'C8',
            colId:'C8',
        },
         {
            field:'C9',
            headerName:'C9',
            colId:'C9',
        },
         {
            field:'C10',
            headerName:'C10',
            colId:'C10',
        },
         {
            field:'C11',
            headerName:'C11',
            colId:'C11',
        },
        {
            field:'C12',
            headerName:'C12',
            colId:'C12',
        },
        {
            field:'C13',
            headerName:'C13',
            colId:'C13',
        },
        {
            field:'C14',
            headerName:'C14',
            colId:'C14',
        },
        {
            field:'C15',
            headerName:'C15',
            colId:'C15',
        }
    ]